//@flow
import React from "react";
//$FlowFixMe
import css from "./circles.module.scss";

const adjustColour =(color,amount)=>{
  return '#' + color.replace(/^#/, '').replace(/../g, color => ('0'+Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));

}

const Circles = (props: { colour: string }): Object => {
  const { colour } = props;
  return (
    <React.Fragment>
      <div className={css.svg_1}>
        <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="0" r="100" style={{ fill: colour }} className={css.c1}/>
          <circle cx="100" cy="0" r="74" style={{fill:adjustColour(colour,40)}} className={css.c2}/>
          <circle cx="100" cy="0" r="48" style={{fill:adjustColour(colour,-60)}} className={css.c3} />
        </svg>
      </div>
      <div className={css.svg_2}>
        <svg viewBox="0 0 100 200" xmlns="http://www.w3.org/2000/svg">
          <circle cx="0" cy="100" r="100"  style={{ fill: colour }}  className={css.c2}/>
          <circle cx="0" cy="100" r="70" style={{fill:adjustColour(colour,40)}}  className={css.c2}/>
          <circle cx="0" cy="100" r="40"style={{fill:adjustColour(colour,-60)}}  className={css.c3}/>
        </svg>
      </div>
      <div className={css.svg_3}>
        <svg viewBox="0 0 100 200" xmlns="http://www.w3.org/2000/svg">
          <circle cx="100" cy="100" r="100"  style={{ fill: colour }}  className={css.c1}/>
          <circle cx="100" cy="100" r="50" style={{fill:adjustColour(colour,40)}} className={css.c2}/>
          <circle cx="100" cy="100" r="30" style={{fill:adjustColour(colour,-60)}} className={css.c3} />
        </svg>
      </div>
      <div className={css.svg_4}>
        <svg viewBox="0 0 100 200" xmlns="http://www.w3.org/2000/svg">
          <circle cx="0" cy="100" r="100"  style={{ fill: colour }}  className={css.c2}/>
          <circle cx="0" cy="100" r="70" style={{fill:adjustColour(colour,40)}}  className={css.c2}/>
          <circle cx="0" cy="100" r="40"style={{fill:adjustColour(colour,-60)}}  className={css.c3}/>
        </svg>
      </div>
    </React.Fragment>
  );
};
export default Circles;
